import { render, staticRenderFns } from "./Sanction.vue?vue&type=template&id=1a681b19"
import script from "./Sanction.vue?vue&type=script&lang=js"
export * from "./Sanction.vue?vue&type=script&lang=js"
import style0 from "./Sanction.vue?vue&type=style&index=0&id=1a681b19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports